import { render, staticRenderFns } from "./fotet.vue?vue&type=template&id=80421afe&scoped=true&"
import script from "./fotet.vue?vue&type=script&lang=ts&"
export * from "./fotet.vue?vue&type=script&lang=ts&"
import style0 from "./fotet.vue?vue&type=style&index=0&id=80421afe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80421afe",
  null
  
)

export default component.exports